import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {normalizeContainerFullWidth} from '@amblique/king-living/app/contentful/utils/normalize-container-full-width';

const helpers = createMultiStyleConfigHelpers(['wrapper', 'root']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("wrapper" | "root")[]
 * }>} ContainerStyles
 */
export const containerStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args
   * @param {Contentful.Container} args.component
   * @returns {ContainerStyles}
   */
  baseStyle({component}) {
    const fullWidth = normalizeContainerFullWidth(component?.fullWidth);
    const backgroundColour = component?.backgroundColour ? String(component.backgroundColour).trim() : null;

    const fullWidthStyles =
      fullWidth === 'No' ?
        {} :
        fullWidth === 'Yes' ?
          {
            maxWidth: '100%',
            width: '100%',
          } :
          fullWidth === 'Yes, Desktop Only' ?
            {
              maxWidth: {base: 'container.xxxl', lg: '100%'},
              paddingX: [4, 4, 6, 0],
            } :
            fullWidth === 'Yes, Mobile Only' ?
              {
                maxWidth: {base: '100%', lg: 'container.xxxl'},
                mx: {base: undefined, lg: 'auto'},
              } :
              {};

    const wrapperStyles = backgroundColour ?
      {width: '100%', backgroundColor: backgroundColour} :
      {};

    return {
      wrapper: wrapperStyles,
      root: {
        ...fullWidthStyles,
      },
    };
  },
});
